<div class="locate-main"
role="dialog"
aria-modal="true"
aria-labelledby="locateDialogTitle">

    <!-- <img class="close-icon cursor-pointer" (click)="closePopUp()" src="assets/icons/close_black_round.png"> -->
     <button
    type="button"
    class="close-btn"
    aria-label="Close dialog"
    (click)="closePopUp()">

    <img
        src="assets/icons/close_black_round.png"
        class="close-icon"
        alt="">

</button>
    <!-- <div class="pop-up-heading">
       Locate Us
    </div> -->
    <h2
    id="locateDialogTitle"
    class="pop-up-heading">

    Locate Us

</h2>
    <div class="col-lg-12">
        <div class="mapouter">
            <div class="gmap_canvas">
               <iframe  width="600" height="500" id="gmap_canvas"
               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.4821818178634!2d72.83814391489997!3d18.998462887132405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7cf5614f65741%3A0x6166e0c04ad59473!2sITI%20House!5e0!3m2!1sen!2sin!4v1638962436673!5m2!1sen!2sin" 
               frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
            </iframe>
            </div>
          </div>
    </div>
   
</div>

<iframe
 
 width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" title="ITI Mutual Fund office location on Google Maps"></iframe>